/// <amd-module name="SuiteCommerce.InventoryDisplay.InventoryDisplay.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.InventoryDisplay.InventoryDisplay.Configuration", ["require", "exports", "SuiteCommerce.InventoryDisplay.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var InventoryDisplayConfiguration = /** @class */ (function (_super) {
        __extends(InventoryDisplayConfiguration, _super);
        function InventoryDisplayConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(InventoryDisplayConfiguration, "inStockMessageForRegularItems", {
            get: function () {
                return this.get('inventoryDisplay.inStockMessageForRegularItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "backorderMessageForRegularItems", {
            get: function () {
                return this.get('inventoryDisplay.backorderMessageForRegularItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "quantityAvailableMessageForRegularItems", {
            get: function () {
                return this.get('inventoryDisplay.quantityAvailableMessageForRegularItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "inStockMessageForSpecialOrderItems", {
            get: function () {
                return this.get('inventoryDisplay.inStockMessageForSpecialOrderItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "backorderMessageForSpecialOrderItems", {
            get: function () {
                return this.get('inventoryDisplay.backorderMessageForSpecialOrderItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "alwaysInStockMessageForSpecialOrderItems", {
            get: function () {
                return this.get('inventoryDisplay.alwaysInStockMessageForSpecialOrderItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "inStockMessageForDropShipItems", {
            get: function () {
                return this.get('inventoryDisplay.inStockMessageForDropShipItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "backorderMessageForDropShipItems", {
            get: function () {
                return this.get('inventoryDisplay.backorderMessageForDropShipItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "alwaysInStockMessageForDropShipItems", {
            get: function () {
                return this.get('inventoryDisplay.alwaysInStockMessageForDropShipItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "lowStockThreshold", {
            get: function () {
                return this.get('inventoryDisplay.lowStockThreshold');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "lowStockMessage", {
            get: function () {
                return this.get('inventoryDisplay.lowStockMessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "hideQuantityForLowStock", {
            get: function () {
                return this.get('inventoryDisplay.hideQuantityForLowStock');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InventoryDisplayConfiguration, "isJSONLdEnabled", {
            get: function () {
                return this.get('structureddatamarkup.type') === 'JSON-LD';
            },
            enumerable: true,
            configurable: true
        });
        return InventoryDisplayConfiguration;
    }(Configuration_1.Configuration));
    exports.InventoryDisplayConfiguration = InventoryDisplayConfiguration;
});
